import {styled} from "@mui/styles";

const FixedIcon = styled("div")({
    width: "64px",
    backgroundColor: "white",
    zIndex: 2,
    // height: "52px",
    // position: "absolute",
    // right: "0px",
    // right: "aut !important",
    // display: "flex",
    // alignItems: "center",
    // justifyContent: "center",
    // boxShadow: "2px 6px 6px #ebebeb",
    // borderTop: "1px solid #e6e6e6",
});

export default FixedIcon;
